import { CommonModule } from "@angular/common";
import { Component, Input, OnDestroy } from "@angular/core";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CerrixAutocompleteComponent } from "@app/incident/components/src/lib/core/cerrix-autocomplete/cerrix-autocomplete.component";
import { CerrixCheckboxComponent } from "@app/incident/components/src/lib/core/cerrix-checkbox/cerrix-checkbox.component";
import { CerrixDatepickerComponent } from "@app/incident/components/src/lib/core/cerrix-date-picker/cerrix-datepicker.component";
import { CerrixDatetimePickerComponent } from "@app/incident/components/src/lib/core/cerrix-datetime-picker/cerrix-datetime-picker.component";
import { CerrixFieldWrapperComponent } from "@app/incident/components/src/lib/core/cerrix-field-wrapper/cerrix-field-wrapper.component";
import { CerrixFinancialImpactComponent } from "@app/incident/components/src/lib/core/cerrix-financial-impact/cerrix-financial-impact.component";
import { CerrixIconComponent } from "@app/incident/components/src/lib/core/cerrix-icon/cerrix-icon.component";
import { CerrixInputNumericComponent } from "@app/incident/components/src/lib/core/cerrix-input-numeric/cerrix-input-numeric.component";
import { CerrixInputComponent } from "@app/incident/components/src/lib/core/cerrix-input/cerrix-input.component";
import { CerrixSelectComponent } from "@app/incident/components/src/lib/core/cerrix-select/cerrix-select.component";
import { CerrixTextareaComponent } from "@app/incident/components/src/lib/core/cerrix-textarea/cerrix-textarea.component";
import { CurrencyInterface } from "@app/incident/components/src/lib/core/models/interfaces/currency.model";
import { SelectOptionModel } from "@app/incident/components/src/lib/core/models/select-option.model";
import { TreeItemNode } from "@app/incident/components/src/lib/core/models/tree/tree-item-node.model";
import { CustomFieldDisplayModel } from "@app/incident/models/custom-field-display.model";
import { FieldType } from "@app/preset/models/field-type.enum";
import { Subscription } from "rxjs";

@Component({
    selector: "incident-custom-fields-section",
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CerrixFieldWrapperComponent,
        CerrixTextareaComponent,
        CerrixInputComponent,
        CerrixInputNumericComponent,
        CerrixIconComponent,
        CerrixAutocompleteComponent,
        CerrixSelectComponent,
        CerrixCheckboxComponent,
        CerrixDatepickerComponent,
        CerrixDatetimePickerComponent,
        CerrixFinancialImpactComponent,
    ],
    templateUrl: "./incident-custom-fields-section.component.html",
    styleUrl: "./incident-custom-fields-section.component.scss"
})
export class IncidentCustomFieldsSectionComponent implements OnDestroy {
    @Input() public sectionName!: string;
    @Input() public isFlat: boolean = false;

    private _customFields: CustomFieldDisplayModel[] = [];
    @Input()
    get customFields(): CustomFieldDisplayModel[] {
        return this._customFields;
    }
    set customFields(fields: CustomFieldDisplayModel[]) {
        this._customFields = fields;
    }

    private _customFieldsForm: FormGroup;
    @Input()
    get customFieldsForm(): FormGroup {
        return this._customFieldsForm;
    }
    set customFieldsForm(form: FormGroup) {
        this._customFieldsForm = form;
    }

    private _currentSelectedOrganizations: TreeItemNode[] = [];
    @Input()
    get currentSelectedOrganizations(): TreeItemNode[] {
        return this._currentSelectedOrganizations;
    }
    set currentSelectedOrganizations(organizations: TreeItemNode[]) {
        this._currentSelectedOrganizations = organizations;
    }

    private _currentSelectedThirdParties: SelectOptionModel[] = [];
    @Input()
    get currentSelectedThirdParties(): SelectOptionModel[] {
        return this._currentSelectedThirdParties;
    }
    set currentSelectedThirdParties(thirdParties: SelectOptionModel[]) {
        this._currentSelectedThirdParties = thirdParties;
    }

    private _currencies: CurrencyInterface;
    @Input()
    get currencies(): CurrencyInterface {
        return this._currencies;
    }
    set currencies(currencies: CurrencyInterface) {
        this._currencies = currencies;
    }

    protected readonly FieldType: typeof FieldType = FieldType;
    protected readonly fullWidthCustomTypes: FieldType[] = [
        FieldType.TextBox,
        FieldType.FinancialImpact,
    ];

    public isSectionOpen: boolean = true;
    public showError: boolean = false;

    private _customFieldsSubscription: Subscription;

    ngOnDestroy(): void {
        this._customFieldsSubscription?.unsubscribe();
    }

    public checkForErrors(): void {
        this.showError = false;
        for (const control of Object.values(this.customFieldsForm.controls)) {
            if (control.errors?.required && control.invalid) {
                this.showError = true;
                this.isSectionOpen = true;
                this._customFieldsSubscription = this.customFieldsForm.valueChanges.subscribe(
                    () => {
                        if (!this.customFieldsForm.invalid) {
                            this.showError = false;
                            this._customFieldsSubscription?.unsubscribe();
                        }
                    }
                );
                return;
            }
        }
    }
}
